<template>
  <chart :data="data" />
</template>
<script>
import Chart from '../Chart'

export default {
  components: {
    Chart,
  },
  props: ['data'],
  data() {
    return {
      value: 'sopo',
      chartValues: {
        sopo: { title: 'Množstvo', decimal: 2, suffix: 'MWh' },
        consumption: { title: 'Množstvo', decimal: 2, suffix: 'm3' },
        totalPrice: {
          title: 'Celková cena',
          decimal: 2,
          suffix: '€ bez dph',
        },
      },
    }
  },
  computed: {
    monthlySeries() {
      let data = []
      data = this.data.filter((item) => {
        return !item.total
      })
      return data.map((item, k) => {
        return {
          name: item.year,
          type: 'column',
          visible: k <= 2,
          data: item.data.map((val) => {
            switch (this.value) {
              case 'sopo':
                return val.sopo
              case 'consumption':
                return val.consumption
              case 'totalPrice':
                return val.totalPrice
            }
          }),
        }
      })
    },
    yearlySeries() {
      return this.data.map((item) => {
        return item.data.reduce((sum, item) => {
          switch (this.value) {
            case 'sopo':
              return sum + item.sopo
            case 'consumption':
              return sum + item.consumption
            case 'totalPrice':
              return sum + item.totalPrice
          }
        }, 0)
      })
    },
  },
}
</script>
